(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["flocking-wind-drift"] = factory();
	else
		root["flocking-wind-drift"] = factory();
})(this, function() {
return 